angular.module('picmonic-common')
    .filter('safeHTML', ['$sce', function($sce){
        return function(input) {
            if(input) {
                return $sce.trustAsHtml(input.toString() + '');
            }
        };
    }]);